<template>
    <div class="notification / flex">
        <VJoyIcon name="info-circle" :color="type" />
        <span>{{ label }}</span>
    </div>
</template>

<script setup lang="ts">
    import {VJoyIcon} from '@maltjoy/core-vue';

    defineProps<{
        label: string;
        type: 'neutral' | 'info';
    }>();
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text';

    .notification {
        color: var(--joy-color-neutral-40);

        @include text.getFontBySize(primary-300);

        gap: var(--joy-core-spacing-2);
        flex-wrap: nowrap;
        align-items: flex-start;
        margin-bottom: var(--joy-core-spacing-3);
    }
</style>
